import React from 'react';
import 'common/invoicePage.css';
import '../../styles/invoicePrint.css';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';

import {
    ArrowBack,
    Email,
    CloudDownload,
    Print
} from '@material-ui/icons';
import  Invoice  from './Invoices/Invoice';
import CustomerService from '../../services/WebCustomerService';
import InvoiceService from '../../services/WebInvoiceService';
import pdfGenerator from '../shared/pdfGenerator'
import InvoiceEmailDialog from './InvoiceEmailDialog';
import {useEffect, useState} from 'react';
import skylineHeaderImage from './Invoices/skyline-invoice-header.png';
import petroffHeaderImage from './Invoices/invoice-header.png';
import config from '../../clientConfig';
import { InvoiceType } from 'common/constants';


const floatingButton = {
    margin: '0px',
    top: 'auto',
    bottom : '30px',
    right : 'auto',
    position : 'fixed'
  };

const styles = {
    backButton: {
        ...floatingButton,
        left: '20px'
    },
    emailButton: {
        ...floatingButton,
        left: '90px'
    },
    printButton: {
        ...floatingButton,
        left: '160px'
    },
    downloadButton: {
        ...floatingButton,
        left: '230px'
    },
    invoicePage:
    {
        background: "rgb(204,204,204)",
        paddingBottom: "10px",
        paddingTop: "10px",
        overflow: "none"
    }
}

export default function InvoicePreviewPage(props) {
    const { customerId, invoiceId } = props.match.params;    
    const invoiceType = props.invoiceType
    const [invoice, setInvoice] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [invoiceEmailDialogOpen, setInvoiceEmailDialogOpen] = useState(false);
    const backClicked = () => {        
        props.history.goBack();
    }

    useEffect(() => {
        if(!isNaN(invoiceId) && invoice == null) {            
          InvoiceService.getInvoice(invoiceId, invoiceType,(data) => {
              setInvoice(data);
          });
        }

        if(!isNaN(customerId) && customer == null) {            
            CustomerService.getCustomer(customerId, (data) => {
                setCustomer(data.results);
            });
        }
    });
    
    const emailClicked = () => {
        if (customer.emails && customer.emails.length > 0) {
            setInvoiceEmailDialogOpen(true);
        } else {
            setAlertOpen(true);
        }        
    }

    const handleClose = () => {
        setInvoiceEmailDialogOpen(false);
    }

    const generateInvoiceFilename = () => {
        return "invoice" + props.match.params.invoiceId + ".pdf";
    }

    const isReady = invoice && customer;
    return (isReady ?
        <div id={'invoicePage'} style={styles.invoicePage}>
            <div style={styles.backButton} className='back floating-button'>
                <Button
                    variant='fab'
                    color='primary'
                    onClick={() => { backClicked() }}>
                    <ArrowBack />
                </Button>
            </div>
            
            <div style={styles.emailButton} className='email floating-button'>
            <Button
                variant='fab'
                color='primary'
                onClick={() => { emailClicked() }}>
                <Email />
            </Button>
            </div>

            <div style={styles.printButton} className='print floating-button'>
                <Button
                    variant='fab'
                    color='primary'
                    onClick={() => {
                        window.print() 
                    }}>
                    <Print />
                </Button>
            </div>
            <div style={styles.downloadButton} className='download floating-button'>
                <Button
                    variant='fab'
                    color='primary'
                    onClick={() => { pdfGenerator.createPdfFile(generateInvoiceFilename()) }}>
                    <CloudDownload />
                </Button>
            </div>

            <Invoice 
                invoice={invoice}
                customer={customer}
                invoiceType={invoiceType}
                imageSrc={skylineHeaderImage}
                petroffImageSrc={petroffHeaderImage}
                isPetroff={config.isPetroff}
            />                    
            <Dialog
                modal={false}
                open={alertOpen}
                onRequestClose={() => setAlertOpen(false)}>
                <DialogTitle>No email for customer</DialogTitle>
                <DialogContent>
                Please enter an email for this customer.
                </DialogContent>
                <DialogActions>
                    <Button
                        color='primary'
                        variant="flat"
                        onClick={() => setAlertOpen(false)}>Ok</Button>
                </DialogActions>

            </Dialog>
            <InvoiceEmailDialog
                open={invoiceEmailDialogOpen}
                customerId={customer.id}
                emails={customer.emails}
                onClose={() => handleClose()}
                invoiceId={InvoiceType.getNumberForInvoice(invoiceType,invoice)}
                invoiceType={invoiceType}
                modal={false}/>
        </div> : <div/>
    );
}

